"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var status = _color.default.status,
    visualInterest = _color.default.visualInterest;
var kindModifiers = {
  primary: function primary() {
    return (0, _styledComponents.css)(["background-color:", ";"], (0, _toColorString.default)(status.information.medium));
  },
  secondary: function secondary() {
    return (0, _styledComponents.css)(["background-color:", ";"], (0, _toColorString.default)(visualInterest.licoriceMousse.medium));
  }
};

var makeSizeModifiers = function makeSizeModifiers(_ref) {
  var size = _ref.size,
      typeScale = _ref.typeScale;
  return (0, _styledComponents.css)(["font-size:", ";height:", ";min-height:", ";width:", ";min-width:", ";"], (0, _rem.default)(_typography.default.size.scale[typeScale]), (0, _rem.default)(size), (0, _rem.default)(size), (0, _rem.default)(size), (0, _rem.default)(size));
};

var sizeModifiers = {
  medium: function medium() {
    return makeSizeModifiers({
      size: 36,
      typeScale: 1
    });
  },
  large: function large() {
    return makeSizeModifiers({
      size: 60,
      typeScale: 4
    });
  }
};

var AvatarContainer = _styledComponents.default.div.withConfig({
  displayName: "AvatarContainer",
  componentId: "sc-16avffw-0"
})(["position:relative;align-items:center;background-color:", ";border-radius:50%;display:inline-flex;height:", ";justify-content:center;width:", ";> span[role='img']{line-height:0;}", ";", ";"], (0, _toColorString.default)(status.information.medium), (0, _rem.default)(36), (0, _rem.default)(36), (0, _styledComponentsModifiers.applyStyleModifiers)(kindModifiers, 'kind'), (0, _styledComponentsModifiers.applyStyleModifiers)(sizeModifiers, 'size'));

var _default = AvatarContainer;
exports.default = _default;